<template>
  <!-- 버츄패스 패널 (GatherPage 버츄패스 탭 + 당근 다이얼로그 공용) -->
  <div>
    <div class="pass-banner">
      <div class="pass-banner__emoji">🎟️</div>
      <div>
        <div class="pass-banner__title">버츄패스</div>
        <div class="pass-banner__desc">버츄펫을 더 풍성하게 즐기는 기간제 패스</div>
      </div>
    </div>

    <div v-if="passLoading" class="py-6 d-flex justify-center">
      <v-progress-circular indeterminate color="#8e6fd6"></v-progress-circular>
    </div>

    <template v-else>
      <v-card v-if="passStatus.active" class="pass-status pass-status--on" outlined>
        <div class="pass-status__badge">이용중</div>
        <div class="pass-status__text">버츄패스 이용 중 · 만료일 {{ formatDate(passStatus.expiredAt) }}</div>
      </v-card>
      <v-card v-else class="pass-status" outlined>
        <div class="pass-status__text">현재 보유한 버츄패스가 없습니다.</div>
        <v-btn class="mt-3" rounded depressed dark color="#8e6fd6" :disabled="!passReady" @click="onBuyPass">
          {{ passReady ? "버츄패스 구매" : "버츄패스 구매 · 준비중" }}
        </v-btn>
      </v-card>
      <p v-if="!passReady" class="text-caption grey--text mt-4">
        ※ 결제 연동(Paddle)은 준비 중입니다. 패스 혜택 구성은 추후 공개됩니다.
      </p>
    </template>
  </div>
</template>

<script>
import BillingApi from "@/api/BillingApi";

export default {
  name: "VirtupassPanel",
  data: () => ({
    passLoading: true,
    passStatus: { active: false, expiredAt: null },
  }),
  computed: {
    passReady() {
      return BillingApi.isCheckoutReady();
    },
  },
  created() {
    this.loadPass();
  },
  methods: {
    async loadPass() {
      this.passLoading = true;
      try {
        this.passStatus = await BillingApi.fetchPassStatus();
      } catch (e) {
        console.error(e);
      } finally {
        this.passLoading = false;
      }
    },
    onBuyPass() {
      BillingApi.startCheckout("VIRTUPASS_30", { onCompleted: () => this.waitForPassActivation() }).catch((e) => {
        const title =
          e && e.message === "E_NOT_LOGGED_IN" ? "로그인 후 이용해주세요." : "버츄패스 결제는 준비 중입니다.";
        this.$notify({ type: "info", title, duration: 2400 });
      });
    },
    // 결제 완료(overlay) 후 webhook의 billing_purchase 적재까지 수 초 지연 — active 될 때까지 폴링
    async waitForPassActivation() {
      for (let i = 0; i < 15; i++) {
        await new Promise((r) => setTimeout(r, 2000));
        const status = await BillingApi.fetchPassStatus().catch(() => null);
        if (status && status.active) {
          this.passStatus = status;
          this.$notify({ type: "success", title: "버츄패스 결제가 완료되었습니다! 🎟️", duration: 3000 });
          return;
        }
      }
      this.$notify({
        type: "info",
        title: "결제가 접수되었습니다. 반영까지 잠시 걸릴 수 있어요.",
        duration: 4000,
      });
      this.loadPass();
    },
    formatDate(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}.${p(d.getMonth() + 1)}.${p(d.getDate())}`;
    },
  },
};
</script>

<style scoped>
.pass-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  border-radius: 16px;
  margin-bottom: 18px;
  background: linear-gradient(135deg, #efe7ff, #e3d4ff);
  border: 1px solid #c9b3f5;
}
.pass-banner__emoji {
  font-size: 40px;
}
.pass-banner__title {
  font-size: 18px;
  font-weight: 800;
  color: #5a3aa0;
}
.pass-banner__desc {
  font-size: 13px;
  color: #7a6aa8;
}
.pass-status {
  padding: 20px 22px;
  border-radius: 16px;
  text-align: center;
}
.pass-status--on {
  background: linear-gradient(135deg, #efe7ff, #e3d4ff);
  border-color: #c9b3f5 !important;
}
.pass-status__badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  background: #8e6fd6;
  border-radius: 999px;
  padding: 2px 10px;
  margin-bottom: 8px;
}
.pass-status__text {
  font-size: 14px;
  font-weight: 600;
  color: #5a3aa0;
}
</style>
